var money_format = function (t, r) {
  function e(t, r) {
    return void 0 === t ? r : t;
  }
  function a(t, r, a, o) {
    if (
      ((r = e(r, 2)), (a = e(a, ",")), (o = e(o, ".")), isNaN(t) || null == t)
    )
      return 0;
    t = (t / 100).toFixed(r);
    var n = t.split(".");
    return (
      n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
      (n[1] ? o + n[1] : "")
    );
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var o = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    i = r || this.money_format;
  switch (i.match(n)[1]) {
    case "amount":
      o = a(t, 2);
      break;
    case "amount_no_decimals":
      o = a(t, 0);
      break;
    case "amount_with_comma_separator":
      o = a(t, 2, ".", ",");
      break;
    case "amount_with_space_separator":
      o = a(t, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      o = a(t, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      o = a(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      o = a(t, 0, ".", "");
      break;
    case "amount_with_space_separator":
      o = a(t, 2, ",", "");
      break;
    case "amount_with_apostrophe_separator":
      o = a(t, 2, "'", ".");
  }
  return i.replace(n, o);
};
/* -------------------------------
   Geo/USP state (global)
   ------------------------------- */
let uspGeoRequested = false;
let userCountryName = null;
const ipgeoKey = "92040e9724fd4f8aaf75d317b69fb8c6";

/* -------------------------------
   Global shipping cache
   ------------------------------- */
let shippingCache = {
  days_charge: "",
  shipping_text: ""
  // ❌ no ship_total here (we want it recalculated every time)
};

/* -------------------------------
   Helper: apply country rules within a root element
   ------------------------------- */
function processCountryElements(rootEl, country_name) {
  if (!rootEl || !country_name) return;

  rootEl.querySelectorAll("[data-allow-country]").forEach(function (element) {
    const allowCountryValue = element.getAttribute("data-allow-country") || "";
    const countries = allowCountryValue.split(",").map(s => s.trim()).filter(Boolean);
    const matched = countries.length === 0
      ? false
      : countries.some(c => c.toLowerCase() === country_name.toLowerCase() || country_name.toLowerCase().includes(c.toLowerCase()));
    element.style.display = matched ? "" : "none";
  });

  rootEl.querySelectorAll("[free_ship_100_bullet]").forEach(function (element) {
    const allowCountryValue = element.getAttribute("data-allow-country") || "";
    const countries = allowCountryValue.split(",").map(s => s.trim()).filter(Boolean);
    if (country_name === "United States") {
      element.style.display = "none";
    } else {
      const matched = countries.some(c => c.toLowerCase() === country_name.toLowerCase() || country_name.toLowerCase().includes(c.toLowerCase()));
      element.style.display = matched ? "none" : "";
    }
  });

  rootEl.querySelectorAll("[free_ship_bullet]").forEach(function (element) {
    if (country_name === "United States") {
      element.style.display = "none";
    } else {
      element.style.display = "";
    }
  });
}

/* -------------------------------
   Request geolocation once
   ------------------------------- */
function requestAndApplyGeolocation(cartSidebar) {
  if (uspGeoRequested) return;
  uspGeoRequested = true;

  _ipgeolocation.getGeolocation(function (response) {
    if (!response || !response.country_name) return;
    userCountryName = response.country_name;

    processCountryElements(document, userCountryName);
    if (cartSidebar) processCountryElements(cartSidebar, userCountryName);

    currentcountry(response);
  }, ipgeoKey);
}

/* -------------------------------
   currentcountry
   ------------------------------- */
function currentcountry(response) {
  var shop_currency = $("#shop_currency_val").text();
  var country_name = response.country_name;
  var currency_rate = Shopify.currency.rate;
  var new_alllist = "";

  $(".oq_countrylist").each(function () {
    var eachcountry = $(this).data("country");
    if (eachcountry.indexOf(country_name) != -1) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }
    new_alllist += eachcountry + ",";
  });

  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var cart_total = cart.total_price,
        ship_text = $(".free_shipping_static_text").attr("data-freeship");

      if (new_alllist.indexOf(country_name) != -1) {
        var $active = $(".oq_countrylist.active");
        var cartfree_cost = parseFloat($active.attr("data-cart") * currency_rate);
        var ship_cost = money_format(parseFloat($active.attr("data-ship") * currency_rate), shop_currency);
        var ship_days = $active.attr("data-day");
        var sub_t = money_format(cart_total + parseFloat($active.attr("data-ship") * currency_rate), shop_currency);

        if (cart_total > cartfree_cost) {
          $(".days_charge").text(ship_days);
          $(".shipping_text").text(ship_text);
          $(".ship_total").text(money_format(cart_total, shop_currency)); // ✅ always refresh

          shippingCache.days_charge = ship_days;
          shippingCache.shipping_text = ship_text;
        } else {
          $(".days_charge").text(ship_days);
          $(".shipping_text").text(ship_cost);
          $(".ship_total").text(sub_t); // ✅ always refresh

          shippingCache.days_charge = ship_days;
          shippingCache.shipping_text = ship_cost;
        }
      } else {
        var ship_days = $(".other_countries").attr("data-day"),
          cartfree_cost = parseFloat($(".other_countries").attr("data-cart") * currency_rate),
          ship_cost = money_format(parseFloat($(".other_countries").attr("data-ship") * currency_rate), shop_currency);
        var sub_t = money_format(cart_total + parseFloat($(".other_countries").attr("data-ship") * currency_rate), shop_currency);

        if (cart_total > cartfree_cost) {
          $(".days_charge").text(ship_days);
          $(".shipping_text").text(ship_text);
          $(".ship_total").text(money_format(cart_total, shop_currency)); // ✅ always refresh

          shippingCache.days_charge = ship_days;
          shippingCache.shipping_text = ship_text;
        } else {
          $(".shipping_text").text(ship_cost);
          $(".days_charge").text(ship_days);
          $(".ship_total").text(sub_t); // ✅ always refresh

          shippingCache.days_charge = ship_days;
          shippingCache.shipping_text = ship_cost;
        }
      }
    },
  });
}

/* -------------------------------
   load_cart()
   ------------------------------- */
function load_cart() {
  fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = "cart-drawer";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart-sidebar");
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;

      // --- Reapply cached values (days_charge + shipping_text only) ---
      if (shippingCache.days_charge) {
        $(".days_charge").text(shippingCache.days_charge);
      }
      if (shippingCache.shipping_text) {
        $(".shipping_text").text(shippingCache.shipping_text);
      }
      // ❌ no ship_total cache here (always live from currentcountry)

      // --- Geo handling ---
      const cartSidebar = document.querySelector(".cart-sidebar");
      if (userCountryName) {
        processCountryElements(cartSidebar, userCountryName);
        currentcountry({ country_name: userCountryName });
      } else {
        requestAndApplyGeolocation(cartSidebar);
      }
      cartgift();
      // --- existing drawer bindings ---
      document.querySelectorAll(".item-remove").forEach(function (cartRemove) {
        var data_line = cartRemove.dataset.line;
        cartRemove.addEventListener("click", (evt) => removeItem(data_line, 0));
      });

      document.querySelectorAll(".remove-free-gift").forEach(element => {
        element.addEventListener("click", function() {
          setTimeout(() => {
            document.querySelectorAll('.product-add-cart .size-selector').forEach(selector => {
              selector.classList.remove('hide');
            });
            document.querySelectorAll('.product-add-cart .main-btn').forEach(btn => {
              btn.classList.remove('hide');
            });
            document.querySelectorAll('.add-cart-btn.success').forEach(btn => {
              btn.classList.add('hide');
            });
          }, 1000);
        });
      });

      document.querySelectorAll(".header-cart").forEach(function (cartButton) {
        cartButton.addEventListener("click", function () {
          document.querySelector("body").classList.add("open-drawer");
          document
            .querySelector("body")
            .classList.remove(
              "open-menu",
              "open-search",
              "open-sort",
              "open-filter"
            );
        });
      });

      document
        .querySelectorAll(".overlay-box,.cart-drawer-close")
        .forEach(function (cartButton) {
          cartButton.addEventListener("click", function () {
            document
              .querySelector("body")
              .classList.remove(
                "open-drawer",
                "open-menu",
                "open-search",
                "open-sort",
                "open-filter"
              );
          });
          return false;
        });

      const url = "/cart.js";
      fetch(url)
        .then((resp) => resp.json())
        .then(function (data) {
          var cart_count = data.item_count;
          document.querySelector(".cart-count").innerHTML = "(" + cart_count + ")";
          document.querySelector(".cart_count_mob").innerHTML = cart_count;

          var productslider = [];
          document.querySelectorAll(".match-with-wrap").forEach(function (Element) {
            let productid = Element.dataset.id;
            let outer_carousel = Element.closest(".match-with-wrapouter");
            let nextbutton = outer_carousel.querySelectorAll(".swiper-button-next")[0];
            let prevbutton = outer_carousel.querySelectorAll(".swiper-button-prev")[0];
            let swiperObject = {
              slidesPerView: "auto",
              loop: eval(Element.dataset.loop),
              navigation: {
                nextEl: nextbutton,
                prevEl: prevbutton,
              },
              breakpoints: {
                576: {
                  slidesPerView: Element.dataset.grid,
                },
              },
            };
            productslider[productid] = new Swiper(Element, swiperObject);
          });

          var h3height = 0;
          $(".match-slider .grid-meta .pro_name").each(function () {
            if (h3height < $(this).outerHeight()) {
              h3height = $(this).outerHeight();
            }
          });
          $(".match-slider .grid-meta .pro_name").height(h3height);
          $(".match-slider .product-images").height("auto");

          var f_ht = $(".drawer-footer").innerHeight();
          $(".drawer-middle").css("padding-bottom", f_ht);

          var d_top =
            $(".drawer-header").outerHeight() +
            $(".product_cart_dv").outerHeight();
          $(".cart-sidebar form").scroll(function () {
            if ($(this).scrollTop() > d_top) {
              // $('.drawer_footer').addClass('fixed_top');
            } else {
              // $('.drawer_footer').removeClass('fixed_top');
            }
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    });
}



/* -------------------------------
   Optional: if some templates insert items into cart later (AJAX),
   you can observe .cart-sidebar and re-apply country rules automatically.
   Uncomment if you want auto re-application when nodes change.
   ------------------------------- */
/*
const cartSidebarObserver = new MutationObserver(function(mutations){
  if (!userCountryName) return; // wait until we know country
  const cartSidebar = document.querySelector('.cart-sidebar');
  if (cartSidebar) processCountryElements(cartSidebar, userCountryName);
});
const cartSidebarEl = document.querySelector('.cart-sidebar');
if (cartSidebarEl) {
  cartSidebarObserver.observe(cartSidebarEl, { childList: true, subtree: true });
}
*/


window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    load_cart();
  }
});
load_cart();
function displayLoading() {
  document.querySelector(".cart-sidebar").classList.add("loading-drawer");
}
function hideLoading() {
  document.querySelector(".cart-sidebar").classList.remove("loading-drawer");
}
function removeItem(data_line, qty) {
  const data = { line: data_line, quantity: qty };
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      load_cart();
      if(document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          setTimeout(function(e){
            document.querySelector('body').classList.add('open-drawer');
          },500);
        }else{
          window.location.href = "/cart";
        }         
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

$(document).on("click", ".right_btn", function (e) {
  e.preventDefault();

  let $row = $(this).closest(".item-row");
  let $dropdown = $row.find(".item-dropdown");
  let $otherDropdowns = $row.siblings().find(".item-dropdown");

  $otherDropdowns.slideUp(300);
  $(".product_cart_dv").css("padding-bottom", "0px");

  $dropdown.slideToggle(300, function () {
    if ($dropdown.is(":visible") && $dropdown.hasClass("last-item")) {
      let h = $dropdown.outerHeight();
      $(".product_cart_dv").css("padding-bottom", h + "px");
    } else {
      $(".product_cart_dv").css("padding-bottom", "0px");
    }
  });

  $(this).toggleClass("active")
    .closest(".item-row")
    .siblings()
    .find(".change-items")
    .removeClass("active");
});

$(document).on("click", ".variant_btn", function (e) {
  e.preventDefault();
  $(this).closest(".cp-variant-btn").find(".item-dropdown").slideToggle().closest(".cp-variant-btn").siblings().find(".item-dropdown").slideUp();
  $(this).toggleClass("active").closest(".cp-variant-btn").siblings().find(".change-items").removeClass("active");
});
$(document).on(
  "click",
  ".item-dropdown li,.cp-variant-dropdown li",
  function (e) {
    e.preventDefault();
    var item_current_id = $(this).data("id");
    var item_current_qty = $(this).data("qty");
    var currentid = $(this).data("current");
    var cartpage_error = $(this).closest(".cp-items-row");
    var cartdrawer_error = $(this).closest(".item-row");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: item_current_id, quantity: item_current_qty },
      dataType: "json",
      beforeSend: function () {},
      success: function (t) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&id=" + currentid,
          dataType: "json",
          beforeSend: function () {
            displayLoading();
          },
          success: function (e) {
            if (window.location.href.includes("cart")) {
              window.location.href = "/cart";
            } else {
              load_cart();
            }
          },
          error: function (e, t) {
            console.log(e.responseJSON.description);
          },
          complete: function () {
            hideLoading();
          },
        });
      },
      error: function (e, t) {
        console.log(e.responseJSON.description);
        $(cartpage_error)
          .find(".cartpage_error")
          .text(e.responseJSON.description);
        $(cartdrawer_error)
          .find(".cartpage_error")
          .text(e.responseJSON.description);
      },
    });
  }
);
$(document).on("click", ".match-slider .product-addcart", function (e) {
  e.preventDefault();
  var match_id = $(this).data("id");
  var _this = $(this).closest(".match-grid");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: match_id, quantity: 1 },
    dataType: "json",
    success: function (t) {
      if (window.location.href.includes("cart")) {
        window.location.href = "/cart";
      } else {
        load_cart();
      }
      $(".cart-sidebar").animate({ scrollTop: 0 }, "slow");
    },
    error: function (e, t) {
      console.log(e.responseJSON.description);
      _this.find(".match-error").text(e.responseJSON.description);
      setTimeout(function () {
        _this.find(".match-error").text("");
      }, 2000);
    },
  });
});
// if ($(window).width() <= 991) {
//   $(document).on("click", ".drwr_ftr_ttl h3", function () {
//     $(this).removeClass("active").siblings().addClass("active");
//     $(this)
//       .parents(".drawer_footer")
//       .find(".cart_sub_total_shipping")
//       .slideToggle();
//     $(".cart-sidebar").toggleClass("active_overlay");
//     $(".cart-sidebar form").animate({ scrollTop: 0 });
//   });
//   $("body").on("click", function (e) {
//     var container = $(".drawer_footer");
//     if (!container.is(e.target) && container.has(e.target).length === 0) {
//       $(".cart-sidebar").removeClass("active_overlay");
//       $(".cart_sub_total_shipping").slideUp();
//     }
//   });
// }

$(document).on("click", ".cd-plus", function (e) {
  e.preventDefault();
  var $qty = $(this).parents(".cd-qty-box").find(".cd-quantity-input");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal)) {
    $qty.val(currentVal + 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest(".cart-item-inr").data("line");
    removeItem(data_line, input_qty);
  }
});
$(document).on("click", ".cd-minus", function (e) {
  e.preventDefault();
  var $qty = $(this).parents(".cd-qty-box").find(".cd-quantity-input");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest(".cart-item-inr").data("line");
    removeItem(data_line, input_qty);
  }
});


function cartgift(){
  const trigger = document.querySelector(".choose_size");
  const drop = document.querySelector(".gift-deskdrop");

  if (trigger && drop) {
    trigger.addEventListener("click", function () {
      const isOpen = drop.classList.contains("open");

      if (isOpen) {
        drop.style.maxHeight = "0px";
        drop.classList.remove("open");
        document.body.classList.remove("active_gift");
      } else {
        drop.style.maxHeight = drop.scrollHeight + "px";
        drop.classList.add("open");
        document.body.classList.add("active_gift");
      }
    });
  }

  // ADD TO CART → click on gift-li
  document.querySelectorAll(".gift-li").forEach(li => {
    li.addEventListener("click", function () {
      const variantId = this.dataset.varId;

      if (!variantId) return;

      // Disable clicking to prevent double add
      this.classList.add("disabled");

      // Shopify AJAX add to cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(res => res.json())
        .then(data => {
          // Success → refresh mini cart or cart drawer
          if (typeof load_cart === "function") {
            load_cart();
          }

          // Close dropdown
          drop.style.maxHeight = "0px";
          drop.classList.remove("open");
          document.body.classList.remove("active_gift");
        })
        .catch(err => {
          console.error("Add to cart error:", err);
        })
        .finally(() => {
          this.classList.remove("disabled");
        });
    });
  });

   document.querySelectorAll(".gift-close, .gift-overlay").forEach(close => {
    close.addEventListener("click", function () {
       const drop = document.querySelector(".gift-deskdrop");
      document.body.classList.remove("active_gift");
      drop.classList.remove("open");
    });
  });
  
}
 cartgift();
